import React, { useCallback, useRef, useState } from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import axios from 'axios'
import apiEndpoints from '../../config/api-endpoints'
import { editStudentRequest } from '../../store/modules/student/actions'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import { UPLOAD_STUDENT_IMAGE } from '../../services/api/UPLOAD_STUDENT_IMAGE'

import {
  Container,
  Content,
  InputAvatar,
  ErrorType,
  ImageStudent,
  ButtonImage,
  ButtonsWrapper,
} from './styles'
import { RootState } from '../../store/modules/rootReducer'
import { toast } from 'react-toastify'

import AvatarPerson from '../../assets/player/avatar-person.svg'

interface ModalProps {
  onClose(): void
  open: boolean
  hidden?: boolean
}

const ModalImageStudent: React.FC<ModalProps> = ({ onClose, open, hidden }) => {
  const dispatch = useDispatch()
  const fileInputRef = useRef<HTMLInputElement>()
  const [errorType, setErrorType] = useState(false)

  const { profile } = useSelector((state: RootState) => state.student)

  window.onclick = function (event: any) {
    if (event.target.id === 'close') onClose()
  }

  const handleDeleteNote = useCallback(
    async (image) => {
      const presignedURLInstance = axios.create()
      if (profile) {
        presignedURLInstance.get(
          `${apiEndpoints.storageApiURL}/upload/area-logada/student/image/delete/${profile.avatar
            .split('/')
            .pop()}`
        )
      }
      dispatch(editStudentRequest({ ...profile, avatar: '' }))
    },
    [dispatch, profile]
  )

  const uploadStudentImage = useCallback(
    (image: any) => {
      if (!image.type) {
        return toast.info('Escolha um arquivo válido')
      }

      const fileName = `${uuidv4()}.${image.name.split('.').pop()}`
      const { url, options } = UPLOAD_STUDENT_IMAGE()
      const instance = axios.create()
      delete instance.defaults.headers.common.Authorization

      instance
        .get(url + fileName, options)
        .then(function (response) {
          if (response?.status === 200) {
            const presignedURLInstance = axios.create()
            return presignedURLInstance
              .put(response.data.presignedURL, image)
              .then(function (responseImage) {
                dispatch(
                  editStudentRequest({
                    ...profile,
                    avatar: response.data.objectURL,
                  })
                )
              })
          }
        })
        .catch(function (err) {
          return console.error(err)
        })
    },
    [profile, dispatch]
  )

  return (
    <Container open={open} id="close">
      <Content hidden={hidden}>
        <ButtonsWrapper>
          <AiOutlineClose id="close" size={30} onClick={onClose} />
        </ButtonsWrapper>
        <ImageStudent src={profile.avatar || AvatarPerson} alt={profile.name} />
        <ButtonsWrapper>
          <ButtonImage
            onClick={(event) => {
              event.preventDefault()
              fileInputRef.current.click()
            }}
          >
            {/* <MdOutlineEdit className="edit" size={30}/> */}
            Editar
          </ButtonImage>
          <ButtonImage
            onClick={() => {
              handleDeleteNote(profile.avatar)
            }}
            isDelete
          >
            Remover
          </ButtonImage>
        </ButtonsWrapper>
        <InputAvatar
          type="file"
          id="file"
          ref={fileInputRef}
          accept="image/jpeg, image/png, image/jpg"
          onChange={(event) => {
            const file = event.target.files[0]
            if (file && file.type.substring(0, 5) === 'image') {
              const reader = new FileReader()

              reader.readAsDataURL(file)
              return uploadStudentImage(file)
            } else {
              setErrorType(true)
              return toast.error('Tipo de arquivo não permitido')
            }
          }}
        />
        {errorType === true || profile.avatar === '' ? (
          <ErrorType className="errorType">Arquivos suportados: jpeg, jpg e png</ErrorType>
        ) : null}
      </Content>
    </Container>
  )
}

export default ModalImageStudent
